function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilterRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 25h2v-7.5L29.5 6.4C30.7 5.1 29.7 3 28 3H4C2.3 3 1.3 5.1 2.5 6.4L13 17.5V29h2V16.7L4 5h24L17 16.7V25z",
    fill: props.color
  }));
}

export default SvgIconFilterRexOutline;